<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" [routerLink]="homeLink">
            <app-logo [logoUrl]="tenantLogoUrl$ | async"></app-logo>
        </a>
    </div>

    <div class="layout-topbar-actions">
        <div class="layout-config-menu"></div>
    </div>

    <!-- <div class="layout-topbar-menu hidden lg:block"> -->
    <div class="flex items-center gap-3">
        <!-- Report Progress -->
        <p-button icon="pi pi-history" [text]="true" [rounded]="true" pTooltip="Report Progress" tooltipPosition="bottom" (click)="goToReportProgress()"></p-button>

        <!-- My Approvals -->
        <p-button icon="pi pi-verified" [text]="true" [rounded]="true" [badge]="pendingApprovalCount > 0 ? pendingApprovalCount.toString() : undefined" badgeSeverity="danger" pTooltip="My Approvals" tooltipPosition="bottom" (click)="goToMyApprovals()"></p-button>

        <!-- Notification Bell -->
        <app-notification-bell></app-notification-bell>

        <!-- User Profile -->
        <div>
            <button #profileBtn type="button" class="profile-button" (click)="menu.toggle($event)">
                <span class="profile-avatar">
                    <i class="pi pi-user"></i>
                </span>
                <span class="profile-info">
                    <span class="profile-name">{{ currentUser?.userLoginInfo?.userName || 'User' }}</span>
                    <span class="profile-role">{{ roleNames || 'User' }}</span>
                </span>
                <i class="pi pi-chevron-down profile-chevron"></i>
            </button>
            <p-menu #menu [popup]="true" [model]="menuItems" [style]="{ 'margin-top': '5px' }"></p-menu>
        </div>
    </div>
</div>

<p-dialog header="Change Password" [(visible)]="changePasswordDialog" [modal]="true" [style]="{ width: '400px' }" [showHeader]="true" styleClass="change-password-dialog" [closable]="true" [closeOnEscape]="true">
    <div class="password-form">
        <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" novalidate>
            <div class="flex flex-wrap gap-2 w-full">
                <label for="currentPassword">Old Password</label>
                <input id="currentPassword" type="password" pInputText formControlName="currentPassword" placeholder="Enter your old password" class="w-full" [ngClass]="{ 'p-invalid': isInvalid('currentPassword') }" />
            </div>
            <div class="flex flex-wrap gap-2 w-full mt-4">
                <label for="newPassword">New Password</label>
                <input id="newPassword" type="password" pInputText formControlName="newPassword" placeholder="Enter your new password" class="w-full" [ngClass]="{ 'p-invalid': isInvalid('newPassword') }" />
                <app-error-message *ngIf="isInvalid('newPassword')" message="Password must be at least 14 characters and a combination of uppercase, lowercase, number, and symbol."></app-error-message>
            </div>
            <div class="flex flex-wrap gap-2 w-full mt-4">
                <label for="confirmPassword">Confirm Password</label>
                <input id="confirmPassword" type="password" pInputText formControlName="confirmPassword" placeholder="Confirm your new password" class="w-full" [ngClass]="{ 'p-invalid': changePasswordForm.hasError('passwordMismatch') }" />
                <app-error-message *ngIf="changePasswordForm.hasError('passwordMismatch')" message="Passwords do not match"></app-error-message>
            </div>

            <div class="dialog-footer">
                <button pButton label="Cancel" severity="secondary" (click)="changePasswordDialog = false"></button>
                <button pButton type="submit" [label]="isChangingPassword ? 'Changing...' : 'Change'" [disabled]="changePasswordForm.invalid || isChangingPassword" class="primary-button">
                    <i class="pi pi-spinner pi-spin" *ngIf="isChangingPassword"></i>
                </button>
            </div>
        </form>
    </div>
</p-dialog>

<p-dialog header="User Profile" [(visible)]="userProfileDialog" [modal]="true" [style]="{ width: '400px' }" [showHeader]="true" styleClass="change-password-dialog" [closable]="true" [closeOnEscape]="true">
    <div class="password-form !pt-0">
        <div class="flex gap-2 w-full mt-1">
            <label>First Name:</label>
            <span>{{ firstName }}</span>
        </div>
        <div class="flex gap-2 w-full mt-1">
            <label>Last Name:</label>
            <span>{{ lastName }}</span>
        </div>
        <div class="flex gap-2 w-full mt-1">
            <label>Role:</label>
            <span>{{ roleNames }}</span>
        </div>
        <div class="flex gap-2 w-full mt-1">
            <label>Email:</label>
            <span>{{ currentUser?.userLoginInfo?.userEmail }}</span>
        </div>
        <div class="dialog-footer">
            <button pButton label="Close" severity="secondary" (click)="userProfileDialog = false"></button>
            <button pButton type="button" label="Update Profile" class="primary-button" (click)="updateProfile()" *ngIf="isTenantAdmin"></button>
        </div>
    </div>
</p-dialog>

<!-- Transfer Role Dialog -->
<p-dialog [header]="isTransferRole ? 'Cancel Transfer Role' : 'Transfer Role'" [(visible)]="transferRoleDialog" [modal]="true" [style]="{ width: '420px' }" [closable]="true" [dismissableMask]="true">
    <div class="password-form !pt-0">
        <form [formGroup]="transferRoleForm" (ngSubmit)="transferRole()" novalidate>
            <!-- Warning message for roles with assigned users -->
            <div class="warning-box mb-2 border-[#FF6200] border-[1px] bg-[#FFF7ED] rounded-[5px] p-[12px]">
                <div class="flex gap-3">
                    <i class="pi pi-exclamation-triangle text-[#FF6200]" style="font-size: 16px"></i>
                    <div>
                        <h3 class="text-[#FF6200] font-bold text-sm mb-2">Warning</h3>
                        <p class="text-sm">This action is permanent, results in immediate loss of access, and cannot be undone.</p>
                    </div>
                </div>
            </div>

            <div class="md:col-span-1 flex flex-col gap-1">
                <label class="form-label" for="employee">Select Employee</label>
                <p-select
                    [options]="employees"
                    formControlName="employee"
                    placeholder="Select an item"
                    optionLabel="userName"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalidTransferRole('employee') }"
                    (onChange)="loadEmployeeDetails()"
                    [readonly]="isTransferRole ? true : false"
                    appendTo="body"
                />
                <app-error-message *ngIf="isInvalidTransferRole('employee')" message="Select an employee to assign privileges to."></app-error-message>
            </div>
            <div class="bg-gray-100 rounded-lg p-4 max-w-sm shadow-sm mt-3" *ngIf="selectedEmployee">
                <span class="text-xl font-semibold text-gray-900 mb-2">{{ selectedEmployee?.name }}</span
                ><br />
                <span class="text-gray-800 font-medium">Role: {{ selectedEmployee?.roleName }}</span
                ><br />
                <span class="text-gray-800 font-medium">Department: {{ selectedEmployee?.departmentName }}</span
                ><br />
                <span class="text-gray-800 font-medium mt-2">Email: {{ selectedEmployee?.email }}</span>
            </div>

            <div class="my-4">
                <label for="password" class="block mb-2 font-medium">Password</label>
                <input id="password" type="password" pInputText formControlName="password" placeholder="Enter password" class="w-full" [ngClass]="{ 'p-invalid': isInvalidTransferRole('password') }" />
                <app-error-message *ngIf="isInvalidTransferRole('password')" message="Enter password to initiate the process"></app-error-message>
            </div>

            <p-divider />

            <!-- <ng-template pTemplate="footer"> -->
            <div class="flex justify-end gap-3 pb-6">
                <button pButton label="Cancel" severity="secondary" (click)="transferRoleDialog = false"></button>
                <button pButton type="submit" [label]="isTransferRole ? 'Cancel Transfer Role' : 'Transfer Role'" class="primary-button"></button>
            </div>
            <!-- </ng-template> -->
        </form>
    </div>
</p-dialog>
